import {
  close_icon,
  menu_mobile,
} from "../../../pages/LandingPage/components/SvgIcon";
const MobileCanvas = ({ mobileMenu, setmobileMenu, children, className = "block md:hidden" }) => {
  return (<>
    <div class={`relative z-[500] ${className}`}>
      <div
        className={`fixed top-0 left-0 h-full w-full bg-white shadow-lg transform z-50 transition-transform duration-300 ${mobileMenu ? "translate-x-0" : "-translate-x-full"
          }`}
      >
        <div class="p-4 flex justify-between items-center border-b">
          <span
            onClick={() => setmobileMenu(!mobileMenu)}
            className={`mobile-menu`}
          >
            {menu_mobile}
          </span>
          <span onClick={(e) => { e.stopPropagation(); setmobileMenu(false) }}>{close_icon}</span>
        </div>
        <div className="overflow-y-auto h-full p-4">
          {children}
        </div>
      </div>
    </div>
  </>)
}

export default MobileCanvas;